import { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig | undefined = {
  token: {
    colorPrimary: '#FF5612',
  },
};
